<template>
 <div>
   <navigationBar></navigationBar>
  <router-view/>
    <footernBar></footernBar>
 </div>
</template>
<script setup>
import footernBar from '@/components/FooterBar.vue'
import navigationBar from '@/components/NavigationBar.vue'
</script>